/** @jsx isolateComponent */
import { isolateComponent, labelStyles } from '@zapier/common-utils';
import { Colors, Icon, Text } from '@zapier/design-system';
import { css } from '@emotion/core';

import Link from 'app/common/components/Link';

const Styles = labelStyles(__filename, {
  container: css`
    background-color: ${Colors.Blue1};
    border-radius: 8px;
    padding: 20px;
    margin-top: 0;
  `,
  title: css`
    display: grid;
    align-items: center;
    grid-auto-flow: column;
    grid-template-columns: 20px 1fr;
    grid-column-gap: 10px;
    margin-bottom: 12px;
    font-weight: 600;
    font-size: 16px;
    line-height: 26px;
  `,
  body: css`
    margin-left: 30px;
  `,
  link: css`
    font-weight: 500;
  `,
});

export const SolutionPartnerInfo = () => {
  return (
    <div css={Styles.container}>
      <div css={Styles.title}>
        <Icon name="personCircleFill" size={20} />
        <Text fontWeight={600}>
          Looking to hire someone to build Zaps or integrations for you?
        </Text>
      </div>
      <div css={Styles.body}>
        <Text tag="p">
          <Link
            css={Styles.link}
            href="https://zapier.com/partnerdirectory"
            target="_blank"
          >
            Browse our directory of Zapier Solution Partners
          </Link>{' '}
          or let us{' '}
          <Link
            css={Styles.link}
            href="https://zapier.com/partnerdirectory/projects/create"
            target="_blank"
          >
            match you with a Zapier Solution Partner.
          </Link>
        </Text>
      </div>
    </div>
  );
};
